import apiClient from './apiClient';

// Ficha "Apertura del plan" (V267): el cliente volvió de ANSES y alguien del estudio abre el plan.
const base = (idTurno) => `/recepcion/turnos/${idTurno}/apertura-plan`;

export const obtenerAperturaPlan = async (idTurno) => (await apiClient.get(base(idTurno))).data;

// registro = { abrioPlan, nroExpediente, motivoNoAbrio, meses27705, monto27705, mesesAComprarCliente,
//   fechaCumpleEdad, compro24476, periodos24476: [{ desde, hasta }], inscribioMonotributo, observacion }
export const registrarAperturaPlan = async (idTurno, registro) => (await apiClient.post(base(idTurno), registro)).data;

// El plan ya estaba abierto: cierra este turno (y el de origen) sin registrar otra apertura.
export const cerrarAperturaPlan = async (idTurno) => (await apiClient.post(`${base(idTurno)}/cerrar`)).data;

// Períodos de la Ley 24.476 que compró el cliente (son aportes del cliente).
export const listarLey24476 = async (cuil) => (await apiClient.get(`/clientes/${cuil}/ley-24476`)).data;
export const agregarLey24476 = async (cuil, periodo) => (await apiClient.post(`/clientes/${cuil}/ley-24476`, periodo)).data;
export const eliminarLey24476 = async (cuil, id) => (await apiClient.delete(`/clientes/${cuil}/ley-24476/${id}`)).data;
